// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"e46cf539","197":"6267a21d","634":"0401cf91","727":"f4783c33","818":"600d2372","950":"ea31c025"}[chunkId] + ".chunk.css";
};